import React from 'react';
import { ReactComponent as ReactLogo } from '../../../../../assets/svg/chevron-right-solid.svg';

function Chevron(props: {
    className?: string;
    height?: string | number;
    width?: string | number;
    fill?: string;
}) {
    return (
        <ReactLogo
            className={props.className}
            width='18px'
            height='18px'
            fill={props.fill}
        />
    );
}

export default Chevron;
